/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "%future added value";
export type MessageBoxContainer_story = {
    readonly settings: {
        readonly messageBox: {
            readonly content: string | null;
            readonly icon: string | null;
        };
        readonly mode: STORY_MODE;
    };
    readonly " $refType": "MessageBoxContainer_story";
};
export type MessageBoxContainer_story$data = MessageBoxContainer_story;
export type MessageBoxContainer_story$key = {
    readonly " $data"?: MessageBoxContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"MessageBoxContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageBoxContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoryMessageBox",
                    "kind": "LinkedField",
                    "name": "messageBox",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "content",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "icon",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'fc62a4df4e5098b0515b07a5c6bb658c';
export default node;
